import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faStopCircle } from '@fortawesome/free-regular-svg-icons'
import { faThumbsUp, faThumbsDown, faFlag, faBookmark, faInfoCircle, faShare, faEye, faCommenting, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons"
import { getYoutubeRemarks, addYoutubeRemarks, addVideoSuggestion } from '../../../redux/actions/userActivity'
import SharePopup from '../../../components/SharePopup'
import { Dialog } from "@headlessui/react"
import { IKImage } from 'imagekitio-react'
import { useRef } from 'react'
import { toast } from 'react-toastify'
import { faTimes } from "@fortawesome/free-solid-svg-icons"
import { ReactComponent as QuestionImg } from './question.svg';
import './index.css'

const Iconbar = ({ videoURL, videoStartTime, videoEndTime, videoDuration, playerDetails, views }) => {
    const dispatch = useDispatch()
    const user_id = useSelector((store) => store?.profileDetails?.id);
    const [openShareModal, setOpenShareModal] = useState(false);
    const [openReportModal, setOpenReportModal] = useState(false);
    const videoSuggestionRef = useRef()
    const videoReplacementRef = useRef()

    const [iconState, setIconState] = useState({
        like: false,
        dislike: false,
        flag: false,
        bookmark: false,
        share: false,
    })

    let playerIcons = [
        { title: 'like', icon: faThumbsUp, type: 'remark' },
        { title: 'dislike', icon: faThumbsDown, type: 'remark' },
        { title: 'bookmark', icon: faBookmark, type: 'remark' },
        { title: 'Report this Video', icon: faTriangleExclamation, type: 'remark' },
        { title: 'Chat Help', icon: QuestionImg, type: 'link', href: `https://api.whatsapp.com/send?phone=919160950649&text=I%20need%20help%20with%20${encodeURIComponent(playerDetails?.['lesson-name'])}%20lesson%20in%20${encodeURIComponent(playerDetails?.mskill_slug)}%20mskill` },
        // {
        //     title: 'Support',
        //     icon: faQuestionCircle,
        //     type: 'link',
        //     href: 'https://docs.google.com/forms/d/e/1FAIpQLSfljcRBZggA1nNJQZHib6mQujv1PTue6vRMB6YDF9uSsLbsCg/viewform'
        // },
        { title: 'Share', icon: faShare, type: 'modal' }
    ]

    useEffect(() => {
        dispatch(getYoutubeRemarks(user_id, videoURL, (data) => setIconState({ ...iconState, ...data })))
    }, [])

    function getStartEndTime(time) {
        let timeDuration;
        if (time > 3601) {
            timeDuration = new Date(time * 1000).toISOString().slice(11, 19);
        } else {
            timeDuration = new Date(time * 1000)
                .toISOString()
                .slice(11, 19)
                .slice(3);
        }

        return timeDuration
    }


    const clickHandler = async (item) => {
        if (item.type === 'remark') {
            if (item.title === 'like') {
                await setIconState({ ...iconState, like: true, dislike: false })
                dispatch(addYoutubeRemarks(user_id, videoURL, { ...iconState, like: true, dislike: false }))
            } else if (item.title === 'dislike') {
                await setIconState({ ...iconState, like: false, dislike: true })
                dispatch(addYoutubeRemarks(user_id, videoURL, { ...iconState, like: false, dislike: true }))
            } else if (item.title === 'Report this Video') {
                await setIconState({ ...iconState, flag: true })
                dispatch(addYoutubeRemarks(user_id, videoURL, { ...iconState, flag: true }))
                setOpenReportModal(true)
            } else {
                await setIconState({ ...iconState, [item.title]: !iconState[item.title] })
                dispatch(addYoutubeRemarks(user_id, videoURL, { ...iconState, [item.title]: !iconState[item.title] }))
            }
        } else if (item.type === 'link') {
            window.open(item.href, '_blank');
        } else if (item.type === 'modal') {
            setOpenShareModal(true);
        }
    }

    const handleReport = () => {
        if (videoSuggestionRef?.current?.value?.length > 0) {
            dispatch(addVideoSuggestion(user_id, playerDetails?.['lesson-videoLink'], videoSuggestionRef?.current?.value, videoReplacementRef?.current?.value, (successObj) => {
                setOpenReportModal(false)
            }))
        }
        else {
            toast.warn("Video reason is mandatory field!")
        }

    }

    const handleViews = (no_of_views) => {

        if(no_of_views === 0){
            return <p className='text-sm font-semibold text-[#64748b]'>{Math.floor(20 + Math.random()*10)}k views</p>
        }



        while (no_of_views < 20000){
            no_of_views = no_of_views * 10
        }
        let views = Math.floor(no_of_views / 1000)
        return <p className='text-sm font-semibold text-[#64748b]'>{views}k views</p>
    }

    return (
        <div className='p-1 mt-2 sm:p-1  w-full px-4 sm:px-6 md:w-5/6'>
            <div className='flex justify-between align-center md:w-[90%]'>
                <div className='flex'>
                    {playerIcons.map((item, i) => (
                        item.title !== "Chat Help" ?
                            <FontAwesomeIcon
                                key={item.title}
                                title={item.title}
                                icon={item.icon}
                                className={`text-slate-500 md:mx-2 mx-1 cursor-pointer text-md sm:text-lg hover:scale-110 ${item.type === 'remark' && iconState[item.title] && 'text-teal-500'}`}
                                onClick={() => clickHandler(item)}
                            />
                            :
                            <QuestionImg onClick={() => window.open(item?.href, "_blank")} className="w-5 h-4 mx-1 cursor-pointer hover:hover:scale-110" />
                    ))}
                </div>

                <div className='mr-0'>
                {
                    videoEndTime > 0 ?
                        <div className='group relative'>
                            <div className='flex justify-center items-center p-1 rounded-lg iconbar-box-shadow' >
                                <FontAwesomeIcon icon={faEye} className="mx-2 text-red-500" size='sm' />
                                <p className='font-bold text-xs md:text-sm text-red-500'>Watch Until {getStartEndTime(videoEndTime)}</p>
                            </div>
                            <div className='hidden group-hover:block absolute top-5 md:w-80 w-48 bg-white z-20'>
                                <p className='text-xs text-gray-500 mt-2'>This Lesson Duration is From {getStartEndTime(videoStartTime)} to {getStartEndTime(videoEndTime)} </p>
                            </div>
                        </div>
                        :
                        <div>
                            {handleViews(views)}
                        </div>
                }
            </div>
            </div>
            <SharePopup open={openShareModal} setOpen={setOpenShareModal} />
            <Dialog open={openReportModal} onClose={() => setOpenReportModal(false)
            }
                as="div"
                className="fixed inset-0 z-10 overflow-y-auto md:-top-10 flex md:justify-start md:mt-28 w-full h-full justify-center flex-col items-center" >
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                <Dialog.Title />
                <Dialog.Description />
                <div className="bg-white relative z-20 flex justify-between flex-col items-start w-11/12 md:p-8 p-2 rounded md:w-2/5">
                    <FontAwesomeIcon icon={faTimes} className="absolute top-3 right-3 md:text-2xl cursor-pointer" onClick={() => { setOpenReportModal(false) }} />
                    <img
                        urlEndpoint="https://assets.learntube.ai/files/"
                        src={"https://assets.learntube.ai/files/Content_player/feedbackModal.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662628545349"}
                        transformation={[{
                            "height": "110",
                            "width": "110",
                        }]}
                        className="md:h-32 h-24"
                    />
                    <h2 className='text-2xl md:text-3xl font-bold mb-3 text-center'>Report This Video</h2>
                    <p className='text-base md:text-lg font-semibold'>What is wrong with this Video?<span className='text-red-500'>*</span></p>
                    <textarea ref={videoSuggestionRef} name="" id="" cols="50" rows="4" placeholder='Describe what is wrong with this video' className='w-full border-2 my-2 border-gray-300 rounded-lg resize-none' required></textarea>
                    <p className='text-base md:text-lg font-semibold mt-3'>Suggest Replacement Video</p>
                    <input ref={videoReplacementRef} type="text" name="" id="" className='w-full border-2 my-2 border-gray-300 rounded-lg' placeholder='Link to video' />
                    <div className='flex justify-center items-center'>
                        <FontAwesomeIcon icon={faInfoCircle} className="text-[#086788]"/>
                        <small className='font-bold text-supertiny ml-2'>You will earn 10 coins for each suggestion that is accepted.</small>
                    </div>
                    <button  className='mt-10  px-3 font-semibold py-2 rounded-lg self-end' onClick={() => handleReport()}>Report Suggestion</button>
                </div>
            </Dialog >
        </div >
    )
}

export default Iconbar